$(document).ready(function(){
    //submit form to get locales
    $("#tryAgain").click(function(e){
        e.preventDefault();
        findAgainShow();
    });
    $("#submit").click(function(e){
        e.preventDefault();
        $('#placeholder').fadeOut();
        postalcode = $('#postalcode').val();
        range = $('#range').val();
        if(advancedSearch == 1){
            day = $('#dayGroup').val();;
            timestart = moment($('#timestart').val(), 'HH:mm').format('HH:mm:ss');
            timeend = moment($('#timeend').val(), 'HH:mm').format('HH:mm:ss');
        }
        //clear existing results
        $('#results').html('');
        $('#searchArea').addClass('hidden');
        waitingForSearch();


        //get data
        $.ajax({
            url: submiturl,
            type: "POST",
            data: {
                "_token" : csrftoken,
                "postalcode" : postalcode,
                "day" : day,
                "timestart" : timestart,
                "timeend" : timeend,
                "range" : range
            },
            success: function(data){
//                        var results = JSON.parse(data);
                doneSearching();
                if(data.length == 0)
                {
                    $('#results').html('<h3>No Congregations were found. Please search again</h3>');
                    findAgain();
                } else {
                    echoJson(data);
                }
//                            $('#placeholder').hide();
            }//end success of map request ajax
        }); //end map request ajax
    }); //end submit


}); //end ready

function ToggleLocDetails(id){
    var w = "#loc" + id;
    var y = "#ico" + id;
    if( $(w).hasClass('hidden') )
    {
        $(w).removeClass("hidden");
        $(y).html("arrow_drop_up");
    } else {
        $(w).addClass("hidden");
        $(y).html("arrow_drop_down");
    }

}




function formatContent(json){
    var wslength = json['worshipservices'].length;
    var output = '<div class="mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp" style="padding: 0px 15px">';
    output += '<div onclick="ToggleLocDetails('+ json['id']+')" class="" meta-id="'+ json['id']+'" style="position: absolute;right: 30px; margin-top: 20px"><i class="material-icons" id="ico'+ json['id']+'">arrow_drop_down</i></div>';
    output +='<div class="mdl-card__supporting-text" > <h5 class="mdl-card__title-text mdl-color-text--blue-grey-500">' + json['name']+ '</h5>';
    // output += '<div style="display:inline-block; float:left;"><i class="material-icons">directions</i></div>';
    output += '<div style="display:inline-block; float:left;">';
    output += '<a href="bingmaps:?cp=' + json['lat'] + '~' + json['lon'] +'">';
    output += '<a href="http://maps.apple.com/maps?q=' + json['lat'] + ',' + json['lon'] +'" class="mdl-button mdl-js-button mdl-color-text--blue-grey-500">';
    output += '<i class="material-icons">directions</i> Navigate </a></a></div>';
    output += '<div style="display:inline-block; float:none; padding-top: 6px;"><p>' + roundNum(json['distance']) + ' miles away</p></div>';
    output += '<div class="hidden" style="float:none; display:block" id="loc' + json['id'] +'">';
    output += '<h6>Address</h6>'
    output += '<address style="padding-left: 20px">';
    output += json['adline1'] + '<br>';
    if(json['adline2']){
        output += json['adline2'] + '<br>';
    }
    output += json['adcity'] + ',' + json['adstateprov']+ ' ' + json['adcode'] + '<br>';
    output += json['adcountry'];
    output += '</address><p>';
    output += '<h6>Worship Service Schedule</h6>'
    output += '<div style="padding: 0px 20px 20px">';
    for (var i = 0; i < wslength; i++) {
        output += formatSchedule(json['worshipservices'][i]);
    }
    output += '</div>';
    output += '<a class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent mdl-color-text--white" style="margin-bottom: 30px;" href="' + baseurl +'/locales/'+ json['slug']+'">More Info</a>';
    output += '</div>'; //end hidden
    output +='</div>'; //end card text
    output +='</div>'; //endcard
  $(output).appendTo('#results');
    return output;
}

function formatSchedule(sched){
    var schedule = sched['day'] + ' ' + sched['time'] + ' in <span style="text-transform: capitalize;">' + sched['language'] + '</span>';
        if(sched['language2']){
            schedule += ' and in ' + sched['language2'];
        }
        if(sched['type'] == "CWS"){
            schedule += " - CWS";
        }
    schedule += '<br>';
    return schedule;

}

function roundNum(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}

function echoJson (results) {


    for (var i = 0; i < results.length; i++) {
        formatContent(results[i]);
    }
    findAgain();

}

function findAgain(){
    $("#findAgain").removeClass('hidden');
}

function findAgainShow(){
    $("#findAgain").addClass('hidden');
    $('#searchArea').removeClass('hidden');
}

function verifyLocation() {
    var pc = $('#postalcode').val();
    if(pc.length > 2)
    {
        $('#submit').removeAttr("disabled");
        showAdvanceButton();
    } else {
        $('#submit').attr("disabled", "disabled");
    }
}

function showAdvanceButton() {
    $('#advancedButton').removeClass('hidden');
}

function filterByAdvance() {
    if( $('#afswitch').is(':checked')){
        $('#filter-advance').addClass('hidden');
        advancedSearch = null;
        day = null;
        timestart = null;
        timesend = null;

    } else {
        $('#filter-advance').removeClass('hidden');
        advancedSearch = 1;
    }
}



function getLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
        alert("Geolocation is not supported by this browser.");
    }
}

function showPosition(position) {
    var latlonx = position.coords.latitude + "," + position.coords.longitude;
    //console.log(latlon);
    $('#postalcode').val(latlonx);
    verifyLocation();
    showAdvanceButton()
}

function showError(error) {
    switch(error.code) {
        case error.PERMISSION_DENIED:
            alert("User denied the request for Geolocation.")
            break;
        case error.POSITION_UNAVAILABLE:
            alert("Location information is unavailable.")
            break;
        case error.TIMEOUT:
            alert("The request to get user location timed out.")
            break;
        case error.UNKNOWN_ERROR:
            alert("An unknown error occurred.")
            break;
    }
}

function doneSearching(){
    $("#wait_holder").addClass('hidden');
}

function waitingForSearch(){
    $("#wait_holder").removeClass('hidden');
}